<div class="flex flex-col max-w-200 md:min-w-0 -m-6 rounded-lg">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg">Difusión Cédula</div>
        <button
            mat-icon-button
            (click)="dialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <div mat-dialog-content>
            <p>¿Se generará la cédula para su difusión? </p>
        </div>
        <div mat-dialog-actions>
            <button mat-button (click)="difundir('SI')">Si</button>
            <button mat-button (click)="difundir('NO')">No</button>
        </div>
    </div>
</div>
